module.exports={close:"Bezárás",error:"Hiba",info:"Információ",success:"Siker",warning:"Figyelmeztetés"};